import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa'; // Import icons from react-icons
import '../styles/LawDisplayPage.css';

const CivilLaw = () => {
  const navigate = useNavigate();
  const buttonContainerRef1 = useRef(null);
  const buttonContainerRef2 = useRef(null);

  const scrollLeft = (ref) => {
    ref.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = (ref) => {
    ref.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    <div className="law-page">
      {/* Heading */}
      <h1>Indian Civil Law</h1>

      {/* Details of Indian Civil Law */}
      <div className="content-section">
        <h2>Details of Indian Civil Law</h2>
        <p>
          Indian civil law is a set of rules and regulations that governs non-criminal disputes
          between individuals, businesses, or organizations. It is also known as private law or
          non-criminal law. Civil law in India is governed by the Code of Civil Procedure, 1908 (CPC)
          and other Acts and Rules.
        </p>
        <p>
          Civil Law comprises a set of rules and regulations that helps in resolving disputes that are 
          non-criminal in nature. The law in India is primarily governed by the Code of Civil Procedure, 
          1908 (CPC), which is a procedural law pertaining to the administration of civil proceedings in India.
        </p>
      </div>

      {/* First Row of Buttons */}
      <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef1)} />
        <div className="button-container" ref={buttonContainerRef1}>
          <button className="big-button">Contract Law</button>
          <button className="big-button" onClick={() => navigate('/family-law')}>
            Family Law
          </button>
          <button className="big-button">Corporate Law</button>
          {/* <button className="big-button" onClick={() => navigate('/search')}>
            Search area
          </button> */}
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef1)} />
      </div>

      {/* Second Row of Buttons */}
      <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef2)} />
        <div className="button-container" ref={buttonContainerRef2}>
          <button className="big-button">Administrative Law</button>
          <button className="big-button">Tort Law</button>
          <button className="big-button">Property Law</button>
          <button className="big-button" onClick={() => navigate('/search')}>
            Search area
          </button>
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef2)} />
      </div>
    </div>
  );
};

export default CivilLaw;
